import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { GradingBlankButton, GradingReplaceButton } from './GradingPushModal.styled';
import type { GradingPushModalProps } from './types';

const ModalHeader = Modal.Header as unknown as React.FC<React.PropsWithChildren<{ className?: string }>>;

/**
 * Asks how grading-group lines should be copied during a push: fill only targets that have no
 * grading data, or replace every target's lines. The choice applies to all selected products.
 */
const GradingPushModal: React.FC<GradingPushModalProps> = ({ show, onConfirm, onCancel }) => {
  const { t } = useTranslation('modules/multi-submit');
  return (
    <Modal show={show} backdrop="static" className="common-custom-modal modal-medium" aria-labelledby="grading-push-title" onHide={onCancel}>
      <ModalHeader>
        <Modal.Title id="grading-push-title">
          <span>{t('PUSH.GRADING_TITLE')}</span>
        </Modal.Title>
        <span onClick={onCancel} className="icon-close cursor-pointer" />
      </ModalHeader>
      <Modal.Body>
        <div className="modal-inner-data">
          <p className="mb-16 text-center">{t('PUSH.GRADING_MESSAGE')}</p>
        </div>
        <div className="common-model-footer">
          <GradingBlankButton onClick={() => onConfirm('blank')}>{t('PUSH.GRADING_BLANK')}</GradingBlankButton>
          <GradingReplaceButton onClick={() => onConfirm('replace')}>{t('PUSH.GRADING_REPLACE')}</GradingReplaceButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GradingPushModal;
